export const NBSP = '\u00a0';
export const WJ = '\u2060';
export const SPACE = '\u0020';
